const productManage = {
  path: 'productManage',
  component: resolve => require(['../../../../../pages/admin/finance/productManage'], resolve),
  meta: {
    requireAuth: true
  }
}

export default productManage
